import { Drawer, Empty, message } from 'antd';
import DateIcon from '../../../assets/date-icon.png';
import Loader from '../Loader';
import { useNavigate } from "react-router";
import dayjs from 'dayjs';
import UserDashboard from '../../../assets/dashboard/user-dashboard.svg';
import { ClearNotifications } from '../../../utils/api';
import { useGlobalContext } from '../../../context/GlobalProvider';

const Notifications = ({ open, setOpen, notifications, loading, setLoading }) => {
    const { setServiceProviderActiveTab } = useGlobalContext();
    const navigate = useNavigate();

    const handleNotificationClick = (e, notification) => {
        e.stopPropagation();
        navigate(notification.title === 'New client joined' ? '/admin/clients' : notification.title === 'New provider joined' ? '/admin/service-providers' : notification.title === "New Review Alert!" ? "/admin/reviews" :  '/admin/support-tickets', { state: { type: 'requested' } });
        if (notification.title === 'New provider joined') {
            setServiceProviderActiveTab('requested');
        }
        setOpen(false);
    }

    const handleClearNotifications = async () => {
        try {
            setLoading(true);
            const resData = await ClearNotifications();
            if (resData?.isSuccess) {
                message.success('Notifications clear!');
                setOpen(false);
            } else {
                message.destroy();
                message.error(resData?.error);
            }
        } catch (error) {
            message.error('An error occurred during the process. Please try again later.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Drawer className='header-notification' title="Notifications" placement="right" onClose={() => setOpen(false)} open={open}>
                <div className='w-full'>
                    {
                        loading ? (
                            <Loader height='h-[70vh]' />
                        ) : notifications && notifications.length > 0 ? (
                            notifications.map((notification) => (
                                <div onClick={(e) => handleNotificationClick(e, notification)} key={notification.id} className='flex flex-col my-2 border-bottom pb-2'>
                                    <div className='flex gap-x-2'>
                                        {/* <span className='w-1.5 h-1.5 mt-[5px] flex-shrink-0 bg-[#cacaca] rounded-full'></span> */}
                                        <div>
                                            <img className='w-6 h-6' src={UserDashboard} alt="user-img" />
                                        </div>
                                        <span className='list text-[11px] font-medium'>{notification.body}</span>
                                    </div>
                                    <div className='flex items-center justify-end gap-x-1'>
                                        <img className='w-3 h-3' src={DateIcon} alt='date-icon' />
                                        <span className='text-[10px] text-right text-black-700'>
                                            {dayjs(notification.created_at).format('DD MMM, YYYY h:mm A')}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className='flex items-center justify-center h-[70vh]'>
                                <Empty description={
                                    <span>
                                        No messages
                                    </span>
                                } />
                            </div>
                        )
                    }
                    {
                        notifications.length > 0 && (
                            <div className='absolute right-8 bottom-7'>
                                <button className='bg-[#61373f] px-6 py-1 rounded-md text-[white] font-semibold' onClick={handleClearNotifications}>Clear</button>
                            </div>
                        )
                    }
                </div>
            </Drawer>
        </>
    );
};
export default Notifications;